import {
  LOAD_SLIDER,
  LOAD_SLIDER_SUCCESS,
  LOAD_SLIDER_ERROR,
  TRANSITION_END,
  NEXT_SLIDE,
  PREVIOUS_SLIDE,
  GO_TO_SLIDE,
  LOAD_COLLECT_HOME,
  LOAD_COLLECT_HOME_SUCCESS,
  LOAD_COLLECT_HOME_ERROR,
} from './constants'

export function loadSlider(name) {
  return {
    type: LOAD_SLIDER,
    name,
  }
}

export function loadSliderSuccess(data, flashMessages) {
  return {
    type: LOAD_SLIDER_SUCCESS,
    data,
    flashMessages,
  }
}

export function loadSliderError(error) {
  return {
    type: LOAD_SLIDER_ERROR,
    error,
  }
}

export function nextSlide() {
  return {
    type: NEXT_SLIDE,
  }
}

export function previousSlide() {
  return {
    type: PREVIOUS_SLIDE,
  }
}

export function goToSlide(slideIndex) {
  return {
    type: GO_TO_SLIDE,
    slideIndex,
  }
}

export function transitionEnd() {
  return {
    type: TRANSITION_END,
  }
}

export function loadCollectHome(name) {
  return {
    type: LOAD_COLLECT_HOME,
    name,
  }
}

export function loadCollectHomeSuccess(data) {
  return {
    type: LOAD_COLLECT_HOME_SUCCESS,
    data,
  }
}

export function loadCollectHomeError(error) {
  return {
    type: LOAD_COLLECT_HOME_ERROR,
    error,
  }
}
